export default __webpack_public_path__ + "static/reward-product-be515f1b029e9a3b892ba41dddcc07b2.png";